/**
 * 송신/공유첨부 경로에서 본문 HTML 의 wrapper element 를 추출.
 *
 * `#nine_body_<mailID>` ID 는 TinyMCE 시절 본문 wrapper 의 식별자. NgwEditor 결과 HTML 에는
 * 본 ID element 가 없어 `querySelector` 가 null 을 반환하며, 후속 `insertBefore` 호출 시
 * TypeError 가 발생한다 (공유 첨부 + 임시저장 회귀, 2026-05-19 사용자 보고). nBody 부재 시
 * `doc.body` 로 폴백하여 NgwEditor 모드에서도 안전하게 자식 노드 삽입을 가능케 한다.
 */
export function extractNBody(doc: Document, nineBodyId: string): HTMLElement {
  return doc.querySelector<HTMLElement>('#' + nineBodyId) ?? doc.body
}

/**
 * SignatureEdit 의 저장 직전 본문 HTML 직렬화. editorType 분기:
 *
 * - **TinyMCE**: `.nine_body` 셀렉터로 본문 wrapper 만 추출 (signature 가 `.nine_body` 안에
 *   들어가는 wrapper 패턴 보존).
 * - **NgwEditor**: `.nine_body` 클래스가 없으므로 body 전체에서 `<style>` 태그만 제거하고
 *   사용. NgwEditor 의 `getHTML({ includeStyles: true })` 결과는 본문 시작에 base styles 의
 *   `<style>` 가 포함되어, 그대로 EML 에 저장하면 재진입 시 PM 의 parseDOM 이 `<style>` 위치
 *   를 처리하면서 빈 paragraph 를 자동 삽입 → 매 저장/재진입마다 본문 위에 빈 줄 누적 회귀
 *   (사용자 보고 2026-05-19, commit a2639f4b7). `<style>` 만 제거하여 누적 방지. base styles
 *   는 메일 클라이언트가 자체 default 스타일을 적용하므로 시각 영향 최소.
 */
export function prepareSignatureBodyHtml(body: string, editorType: string): string | undefined {
  if (editorType === 'ngw') {
    const doc = new DOMParser().parseFromString(body, 'text/html')
    doc.querySelectorAll('style').forEach((styleEl) => styleEl.remove())
    return doc.body.innerHTML
  }
  const doc = new DOMParser().parseFromString(body, 'text/html')
  const nBody = doc.querySelector('.nine_body')
  return nBody?.outerHTML
}
